<!-- components/GuiaGrabacionAudio.vue -->
<template>
    <v-dialog v-model="dialogVisible" max-width="800" persistent scrollable>
        <v-card class="elevation-12">
            <!-- Header -->
            <v-card-title class="primary white--text py-4">
                <v-icon left dark large>mdi-microphone</v-icon>
                <span class="headline ml-3">Guía para grabar el contenido del proceso en audio</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="cerrar">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <!-- Contenido principal -->
            <v-card-text class="pa-6">
                <p class="mb-6 text-body-1">
                    Para que la grabación sea clara, estructurada y cumpla con los requisitos de documentación (ISO
                    9001:2015),
                    <strong>graba tu voz siguiendo esta estructura exacta</strong>. Habla de forma pausada y clara.
                </p>

                <ol class="guia-lista">
                    <li>
                        <strong>¿Cómo se llama el proceso que estás describiendo?</strong>
                        <p class="ml-6 grey--text text--darken-2">
													Ejemplo: Proceso de Inscripción de Alumnos.
                        </p>
                    </li>

                    <li>
                        <strong>¿Cuál es el objetivo de este proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
													Ejemplo: Garantizar la correcta inscripción de los alumnos conforme a los requisitos
													establecidos.
                        </p>
                    </li>

                    <li>
                        <strong>¿Cuál es el alcance del proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
													¿Desde dónde inicia y en qué punto termina?
													Ejemplo: Desde la recepción de la solicitud del alumno hasta la confirmación de su
													inscripción.
                        </p>
                    </li>

                    <li>
                        <strong>¿Cuáles son las entradas necesarias para que este proceso pueda ejecutarse? Es
													decir, ¿Qué información o cosas necesitas para poder hacer este proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                            Ejemplos:
                        </p>
                        <ul class="ml-10">
                            <li>Solicitud del cliente</li>
                            <li>Información del alumno</li>
                            <li>Requisitos internos</li>
                            <li>Políticas institucionales</li>
                        </ul>
                    </li>

                    <li>
                        <strong>¿Cuáles son las salidas o resultados del proceso? Es decir, ¿Qué es lo que se
													entrega o se obtiene al final del proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                            Ejemplos:
                        </p>
                        <ul class="ml-10">
                            <li>Alumno inscrito</li>
                            <li>Confirmación administrativa</li>
                            <li>Registro en sistema</li>
                        </ul>
                    </li>

                    <li>
                        <strong>¿Cómo se lleva a cabo el proceso paso a paso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                          Describe la secuencia de actividades y cómo interactúa con otros procesos o áreas.
                        </p>
                    </li>

                    <li>
                        <strong>¿Quién es el responsable del proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
													¿Qué rol o puesto tiene la autoridad sobre su ejecución y resultados?
													Ejemplo: Coordinador académico o responsable administrativo.
                        </p>
                    </li>

                    <li>
                        <strong>¿Qué recursos son necesarios para operar este proceso? Es decir, ¿Qué necesitas
													para poder hacer bien este proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                            Ejemplos:
                        </p>
                        <ul class="ml-10">
                            <li>Personal capacitado</li>
                            <li>Infraestructura</li>
                            <li>Software y herramientas</li>
                            <li>Información documentada</li>
                        </ul>
                    </li>

                    <li>
                        <strong>¿Qué riesgos pueden afectar el proceso y qué oportunidades existen para
													mejorarlo?</strong>
                        <p class="ml-6 grey--text text--darken-2">
													Ejemplo: Riesgo de errores en la información del alumno; acción: validación previa de
													datos.
                        </p>
                    </li>

                    <li>
                        <strong>¿Cómo se mide el desempeño del proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                            Ejemplos:
                        </p>
                        <ul class="ml-10">
                            <li>Tiempo promedio de inscripción</li>
                            <li>Porcentaje de errores administrativos</li>
                            <li>Nivel de satisfacción del cliente</li>
                        </ul>
                    </li>

                    <li>
                        <strong>¿Cómo se da seguimiento y control al proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                            Ejemplos:
                        </p>
                        <ul class="ml-10">
                            <li>Revisión periódica de indicadores</li>
                            <li>Auditorías internas</li>
                            <li>Evaluaciones de resultados</li>
                        </ul>
                    </li>

                    <li>
                        <strong>¿Qué documentación y registros se generan como evidencia del proceso? Es
													decir, ¿Qué papeles, archivos o registros se generan cuando haces este proceso?</strong>
                        <p class="ml-6 grey--text text--darken-2">
                            Ejemplos:
                        </p>
                        <ul class="ml-10">
                            <li>Formatos</li>
                            <li>Registros</li>
                            <li>Procedimientos</li>
                            <li>Reportes</li>
                        </ul>
                    </li>
                </ol>

                <v-divider class="my-6"></v-divider>

                <div class="text-caption grey--text text--darken-1 text-center">
                    Consejos prácticos para una buena grabación:
                </div>
                <ul class="text-caption grey--text text--darken-1 mt-2">
                    <li>Habla despacio y con pausas claras entre puntos.</li>
                    <li>Usa un ambiente sin ruido de fondo.</li>
                    <!-- <li>Graba en bloques si el proceso es muy largo (puedes unir después si es necesario).</li> -->
                    <li>Revisa la grabación antes de guardar.</li>
                </ul>
            </v-card-text>

            <!-- Footer con acciones -->
            <v-card-actions class="px-6 pb-6">
                <v-spacer></v-spacer>


                <v-btn color="primary" text @click="empezarGrabacion">
                    <v-icon left>mdi-microphone</v-icon>
                    ¡Entendido! Empezar a grabar
                </v-btn>
                <v-btn color="error" text @click="cerrar">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'GuiaGrabacionAudio',

    props: {
        value: {
            type: Boolean,
            default: false
        },
    },

    data: () => ({
        dialogVisible: false
    }),

    watch: {
        value(nuevo) {
            this.dialogVisible = nuevo
        },
        dialogVisible(nuevo) {
            this.$emit('input', nuevo)
        }
    },

    methods: {
        cerrar() {
            this.dialogVisible = false
        },

        empezarGrabacion() {
            this.$emit('empezar-grabacion')
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
.guia-lista {
    counter-reset: guia-counter;
    list-style: none;
    padding-left: 0;
}

.guia-lista>li {
    counter-increment: guia-counter;
    margin-bottom: 1.5rem;
    position: relative;
    padding-left: 2.5rem;
}

.guia-lista>li::before {
    content: counter(guia-counter) ".";
    position: absolute;
    left: 0;
    font-weight: bold;
    color: #1976d2;
    font-size: 1.3rem;
}
</style>